import { render, staticRenderFns } from "./DeleteDetail.vue?vue&type=template&id=efe9a748&"
import script from "./DeleteDetail.vue?vue&type=script&lang=js&"
export * from "./DeleteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports